export default __webpack_public_path__ + "static/media/liquidus_logo.f7306dc2.png";